// Styles
import "./VCode.css";

// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VCode = createSimpleFunctional('v-code');
//# sourceMappingURL=index.mjs.map